export const initialPaginationModelValues = {
  page: 0,
  pageSize: 10,
};

export const defaultPageSizeOptions = [10, 20, 30];

export const codelist_categories = [
  { value: "System", label: "System" },
  { value: "Modifiable", label: "Modifiable" },
  { value: "Extensible", label: "Extensible" },
];
